import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { WarehouseProvider} from "../../ClientApp/src/pages/dashbaord/season/WarehouseContext"
import { ClusterProvider } from "../../ClientApp/src/pages/dashbaord/season/manage season/states/ClusterContext";


ReactDOM.render(
  <React.StrictMode>
     {/* <BrowserRouter> */}
     
     <WarehouseProvider>
      <ClusterProvider>
      <App />
      </ClusterProvider>
      </WarehouseProvider>
     
    {/* </BrowserRouter> */}
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
